/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboard',
        subtitle: 'Unique dashboard designs',
        type: 'aside',
        icon: 'heroicons_outline:home',
        link: '/home'
    },
    {
        id: 'reportCustomers',
        title: 'Clienti',
        type: 'aside',
        icon: 'heroicons_outline:calendar',
        link: '/report-customers',
        exactMatch: false
    },
    // {
    //     id: 'reports',
    //     title: 'Report',
    //     type: 'group',
    //     icon: 'heroicons_outline:chart-bar',
    //     children: [
    //         {
    //             id: 'reportSuppliers',
    //             title: 'Fornitori',
    //             type: 'basic',
    //             link: '/report-suppliers'
    //         },
    //         {
    //             id: 'reportSales',
    //             title: 'Vendite',
    //             type: 'basic',
    //             link: '/report-sales'
    //         },
    //         {
    //             id: 'reportProducts',
    //             title: 'Prodotti',
    //             type: 'basic',
    //             link: '/report-products'
    //         },
    {
        id: 'reportContracts',
        title: 'Contratti',
        type: 'basic',
        link: '/contracts'
    },
     {
        id: 'reportContractCompetitor',
        title: 'Competitors',
        type: 'basic',
        link: '/report-contract-competitor'
    },
    //         {
    //             id: 'reportAgents',
    //             title: 'Agenti',
    //             type: 'basic',
    //             link: '/report-agents'
    //         },

    //     ],
    // },
    {
        id: 'transactions',
        title: 'Forniture',
        type: 'aside',
        icon: 'heroicons_outline:circle-stack',
        link: '/transactions'
    },
    // {
    //     id: 'contracts',
    //     title: 'Contratti',
    //     type: 'aside',
    //     icon: 'heroicons_outline:pencil',
    //     link: '/contracts'
    // },

    // {
    //     id: 'archive',
    //     title: 'Documenti',
    //     type: 'aside',
    //     icon: 'heroicons_outline:calendar',
    //     link: '/archive'
    // },
    // {
    //     id: 'crm',
    //     title: 'CRM',
    //     type: 'aside',
    //     icon: 'heroicons_outline:calendar',
    //     link: '/crm'
    // },
    // {
    //     id: 'activities',
    //     title: 'Attività',
    //     type: 'aside',
    //     icon: 'heroicons_outline:calendar',
    //     link: '/activities'
    // },
    // {
    //     id: 'commissions',
    //     title: 'Provvigioni',
    //     type: 'aside',
    //     icon: 'heroicons_outline:calendar',
    //     link: '/commissions'
    // },

    {
        id: 'imports',
        title: 'Imports',
        type: 'aside',
        icon: 'heroicons_outline:arrow-up-tray',
        link: '/jobs'
    },
    {
        id: 'configurations',
        title: 'Configurazione',
        type: 'group',
        icon: 'heroicons_outline:home',
        children: [
            {
                id: 'companies',
                title: 'Aziende',
                type: 'basic',
                link: '/companies'
            },
            {
                id: 'customers',
                title: 'Clienti',
                type: 'basic',
                link: '/customers'
            },
             {
                id: 'customer-destination',
                title: 'Destinazioni clienti',
                type: 'basic',
                link: '/customer-destination'
            },
            {
                id: 'suppliers',
                title: 'Fornitori',
                type: 'basic',
                link: '/suppliers'
            },
            {
                id: 'products',
                title: 'Prodotti',
                type: 'basic',
                link: '/products'
            },
            {
                id: 'categories',
                title: 'Linee di prodotti',
                type: 'basic',
                link: '/categories'
            },
            {
                id: 'agents',
                title: 'Agenti',
                type: 'basic',
                link: '/agents'
            },
            {
                id: 'users',
                title: 'Utenti',
                type: 'basic',
                link: '/users'
            }
        ],
    },
    {
        id: 'divider-1',
        type: 'divider',
    }
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id: 'dashboards',
        title: 'Dashboard',
        subtitle: 'Unique dashboard designs',
        type: 'basic',
        icon: 'heroicons_outline:home',
        link: '/home'
    },
    {
        id: 'reportCustomers',
        title: 'Clienti',
        type: 'basic',
        icon: 'heroicons_outline:users',
        link: '/report-customers',

    },
    // {
    //     id: 'reports',
    //     title: 'Report',
    //     type: 'aside',
    //     icon: 'heroicons_outline:chart-bar',
    //     link: '/report-suppliers',
    //     children: [],
    // },    
    {
        id: 'contracts',
        title: 'Contratti',
        type: 'basic',
        icon: 'heroicons_outline:pencil',
        link: '/contracts'
    },
    {
        id: 'contractCompetitors',
        title: 'Competitors',
        type: 'basic',
        icon: 'heroicons_outline:fire',
        link: '/contract-competitor'
    },
    {
        id: 'transactions',
        title: 'Forniture',
        type: 'basic',
        icon: 'heroicons_outline:circle-stack',
        link: '/transactions'
    },


    // {
    //     id: 'archive',
    //     title: 'Documenti',
    //     type: 'basic',
    //     icon: 'heroicons_outline:folder-open',
    //     link: '/archive'
    // },
    // {
    //     id: 'crm',
    //     title: 'CRM',
    //     type: 'basic',
    //     icon: 'heroicons_outline:user-circle',
    //     link: '/crm'
    // },
    // {
    //     id: 'activities',
    //     title: 'Attività',
    //     type: 'basic',
    //     icon: 'heroicons_outline:check-circle',
    //     link: '/activities'
    // },
    // {
    //     id: 'commissions',
    //     title: 'Provvigioni',
    //     type: 'basic',
    //     icon: 'heroicons_outline:banknotes',
    //     link: '/commissions'
    // },
    {
        id: 'imports',
        title: 'Imports',
        type: 'basic',
        icon: 'heroicons_outline:arrow-up-tray',
        link: '/jobs'
    },
    {
        id: 'configurations',
        title: 'Configurazione',
        type: 'aside',
        icon: 'heroicons_outline:cog-6-tooth',
        link: '/example',
        children: [],
    }
]; 